import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ConstantsService } from './constants-service';

import 'rxjs/add/operator/toPromise';

/**
 * Generic service for sending HTTP requests that returns a Promise as response.
 *
 * @author naveenkiran@vernuso.com (Naveen Kiran)
 */
@Injectable()
export class PromiseRequestService {

  constructor(private _http: Http) { }

  getRequest(requestUrl: string): Promise<any> {
    const url = ConstantsService.APP_BE_URL + '/rest' + requestUrl;
    return this._http
      .get(url)
      .toPromise()
      .then(response => response.json() as Object)
      .catch(this.handleError);
  }

  postRequest(requestUrl: string, body: Object): Promise<any> {
    const url = ConstantsService.APP_BE_URL + '/rest' + requestUrl;
    return this._http
      .post(url, JSON.stringify(body), { headers: ConstantsService.FORM_CONTENT_TYPE_HEADER })
      .toPromise()
      .then(res => res.json() as Object)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promise-request.service.ts